import React from 'react';
import News from './News'
import Products from './Products'
import Ecosphere from './Ecosphere'
import AboutUs from './AboutUs';
import './index.scss';
import { cookieUtil } from '@/assets/js/cookie'
// import { withRouter } from 'react-router'

class App extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      bannerImages: [
        { name: "工程设计", attachURL: "/Products/ProductDetails/EngineeringDesign", imgPath: require("img/3pic.png"), imgHDPath: `${require("img/3pic.png")} 1x,${require("img/3pic@2x.png")} 2x,${require("img/3pic@3x.png")} 3x`, },
        { name: "全过程工程咨询", attachURL: "/Products/ProductDetails/WholeProcess", imgPath: require("img/1pic.png"), imgHDPath: `${require("img/1pic.png")} 1x,${require("img/1pic@2x.png")} 2x`, },
      ],
    }
  }
  componentDidMount() {
    // 初始化swiper
    new window.Swiper('.swiper-home', {
      loop: true,
      autoplay: {
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-home-pagination',
        bulletActiveClass: 'my-bullet-active',
      }
    })
    // 回显高度
    setTimeout(() => {
      var cacheHeight = cookieUtil.get('indexCacheHeight')
      if (document.documentElement.scrollTop) {
        document.documentElement.scrollTop = cacheHeight
      } else if (document.body.scrollTop) {
        document.body.scrollTop = cacheHeight
      } else {
        document.body.scrollTop = cacheHeight
      }
    }, 100);
    // 设置高度
    const dom = document.getElementsByClassName('App-body')[0]
    dom.addEventListener('touchstart', this.onScrollTop.bind(this), false)
    dom.addEventListener('touchmove', this.onScrollTop.bind(this), false)
    dom.addEventListener('touchend', this.onScrollTop.bind(this), false)
  }
  onScrollTop () {
    var height = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
    cookieUtil.set('indexCacheHeight', height)
  }
  componentWillUnmount () {
    const dom = document.getElementsByClassName('App-body')[0]
    dom.removeEventListener('touchstart', this.onScrollTop.bind(this), false)
    dom.removeEventListener('touchmove', this.onScrollTop.bind(this), false)
    dom.removeEventListener('touchend', this.onScrollTop.bind(this), false)
  }
  render() {
    return (
      <React.Fragment>
        <main className="App-body">
          <section className="swiper-container swiper-home">
            <div className="swiper-wrapper">
              {
                this.state.bannerImages.map((item, index) =>
                item.attachURL && item.attachURL !== '/' ?
                  <a className="swiper-slide"
                    key={index}
                    href={item.attachURL}>
                    <img src={item.imgPath} alt="" srcSet={item.imgHDPath} width="100%" height="100%" />
                  </a>
                  :
                    <img key={index} src={item.imgPath} alt="" srcSet={item.imgHDPath} width="100%" height="100%" />
                )
              }
            </div>
            <div className="swiper-pagination swiper-home-pagination"></div>
          </section>
          <News />
          <Products />
          <Ecosphere />
          <AboutUs />
        </main>
      </React.Fragment>
    );
  }
}

export default App;
